import React from 'react';
import './GlossaryEditor.scss';
import { Tabs } from '../../../FormComponents/Tabs/Tabs';
import { Tab } from '../../../FormComponents/Tabs/Tab';
import { TabPanel } from '../../../FormComponents/Tabs/TabPanel';
import { ReplaceEditor } from './ReplaceEditor/ReplaceEditor';
import { DoNotTranslateEditor } from './DoNotTranslateEditor/DoNotTranslateEditor';
import { TokensEditor } from './TokensEditor/TokensEditor';
import { FormatEditor } from './FormatEditor/FormatEditor';
import { ClassToken, DoNotTranslate, Replace, Format } from '../../../../types/Glossary';

type Props = {
  replace: Replace[];
  setReplace: React.Dispatch<React.SetStateAction<Replace[]>>;
  format: Format[];
  setFormat: React.Dispatch<React.SetStateAction<Format[]>>;
  doNotTranslate: DoNotTranslate[];
  setDoNotTranslate: React.Dispatch<React.SetStateAction<DoNotTranslate[]>>;
  tokens: ClassToken[];
  setTokens: React.Dispatch<React.SetStateAction<ClassToken[]>>;
  activeIndex: number,
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlossaryEditor = (props: Props) => {
  return (
    <>
      <Tabs activeIndex={props.activeIndex} setActiveIndex={props.setActiveIndex}>
        <Tab>Formatting</Tab>
        <Tab>Replace</Tab>
        <Tab>Do Not Translate</Tab>
        {/* <Tab>Tokens</Tab> */}

        <TabPanel>
          <FormatEditor
            data={props.format}
            setData={props.setFormat}
            setIsDirty={props.setIsDirty}/>
        </TabPanel>
        <TabPanel>
          <ReplaceEditor
            data={props.replace}
            setData={props.setReplace}
            setIsDirty={props.setIsDirty}/>
        </TabPanel>
        <TabPanel>
          <DoNotTranslateEditor
            data={props.doNotTranslate}
            setData={props.setDoNotTranslate}
            setIsDirty={props.setIsDirty}/>
        </TabPanel>
        {/* <TabPanel>
          <TokensEditor
            data={props.tokens}
            setData={props.setTokens}
            setIsDirty={props.setIsDirty}/>
        </TabPanel> */}
      </Tabs>
    </>
  );
};
